module.exports = __webpack_public_path__ + "img/car1_5.ebb8eb61.png";